import { validate as isUuid } from 'uuid'

const UTC_TIMESTAMP_PATTERN = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/

export const isRecord = value =>
    value !== null && typeof value === 'object' && !Array.isArray(value)

export const hasOwn = (value, property) =>
    isRecord(value) && Object.prototype.hasOwnProperty.call(value, property)

export const isNonEmptyString = value =>
    typeof value === 'string' && Boolean(value.trim())

export const isValidTimestamp = value =>
    isNonEmptyString(value) && !Number.isNaN(Date.parse(value))

export const isValidUtcTimestamp = value =>
    isValidTimestamp(value) && UTC_TIMESTAMP_PATTERN.test(value)

export const isValidV1EventEnvelope = (
    envelope,
    { eventTypes, validateData }
) =>
    isRecord(envelope) &&
    envelope.version === 1 &&
    eventTypes.has(envelope.type) &&
    isUuid(envelope.id) &&
    isUuid(envelope.correlation_id) &&
    isValidUtcTimestamp(envelope.occurred_at) &&
    validateData(envelope.type, envelope.data)
